const computeIsLuxury = (data) => {
  return data?.title === 'Luxury'
}

export default computeIsLuxury
